export default __webpack_public_path__ + "static/media/Print-487.18451a2a.jpg";